import type { ContenidoAyuda } from "@/ui/AyudaVista";

/**
 * Ayuda de Administración (usuarios). Antes, el «?» con globito y los
 * tooltips de los botones de cada fila.
 */
export function ayudaAdmin(): ContenidoAyuda {
  return {
    manual: "configuracion",
    intro: (
      <p>
        Las cuentas de quienes entran a ArkTickets: crearlas, cambiarles el rol, ponerles
        contraseña nueva y desactivarlas. Solo los admins ven esta página.
      </p>
    ),
    secciones: [
      {
        titulo: "Qué hace cada botón",
        items: [
          {
            label: "+ Nuevo usuario",
            text: "Abre el formulario para dar de alta una cuenta: correo, nombre, contraseña inicial (mínimo 8 caracteres), rol y por dónde le llegan los avisos.",
          },
          {
            label: "Activo / Inactivo",
            text: "Tócalo para desactivar o reactivar la cuenta. Desactivar no borra nada: la persona ya no puede entrar y su sesión abierta se corta. Sale gris en tu propia cuenta (no puedes desactivarte), y tampoco se deja desactivar al último admin activo.",
          },
          {
            label: "Editar",
            text: "Cambia el nombre, el rol, los avisos por correo y por Telegram, el asistente de IA en correos y el chat de Telegram. El correo de la cuenta no se cambia aquí.",
          },
          {
            label: "Pass / Restablecer contraseña",
            text: "Le pone una contraseña nueva (mínimo 8 caracteres); la anterior deja de servir. Pásasela tú a la persona: el sistema no se la manda.",
          },
        ],
      },
      {
        titulo: "Qué significa cada indicador",
        items: [
          {
            label: "ADMIN / SOPORTE / USUARIO",
            text: "El rol. Admin: todo, incluidas Administración y Configuración. Soporte: trabaja los casos (crear, editar, enviar correos). Usuario: solo consulta. No se puede quitarle el rol de admin al último admin activo.",
          },
          {
            label: "✉ / tg",
            text: "Columna «Notif»: ✉ = recibe avisos por correo; tg = recibe avisos por Telegram (si además vinculó su Telegram). «—» = sin avisos por correo.",
          },
          { label: "Fila en gris", text: "Cuenta desactivada." },
        ],
      },
    ],
  };
}
